"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginPage = void 0;
var react_1 = __importDefault(require("react"));
var react_helmet_1 = require("react-helmet");
var UserManager_1 = __importDefault(require("App/util/UserManager"));
var Loader_1 = __importDefault(require("App/components/Loader"));
exports.LoginPage = function () {
    react_1.default.useEffect(function () {
        UserManager_1.default.signinRedirect();
    }, []);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_helmet_1.Helmet, { title: "Login" }),
        react_1.default.createElement(Loader_1.default, null)));
};
exports.default = {
    name: 'Login',
    routeProps: {
        path: '/login',
        component: exports.LoginPage,
    },
};
//# sourceMappingURL=login.js.map